import Spinner from '@plato/ui-legacy/components/ui/spinner';
import { cn } from '@plato/ui/util/classes';

type ChartLoadingProps = {
    className?: string;
};

export function ChartLoading({ className }: ChartLoadingProps) {
    return (
        <div className={cn('flex h-72 items-center justify-center text-center', className)}>
            <Spinner />
        </div>
    );
}
